import { type ChangeEvent, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ButtonRow, HelperText, MfaFormContainer, StyledField, StyledInput, SubmitButton } from './Mfa.styled';

const VERIFICATION_CODE_LENGTH = 6;

const messages = defineMessages({
  codeHelper: {
    id: 'mfaCodeHelper',
    defaultMessage: 'This should be a 6-digit verification code generated by the app.'
  }
});

interface MfaCodeFormProps {
  readonly codeLabel: string;
  readonly codePlaceholder: string;
  readonly buttonLabel: { id: string; defaultMessage: string };
}

export const MfaCodeForm = ({ codeLabel, codePlaceholder, buttonLabel }: MfaCodeFormProps) => {
  const [code, setCode] = useState('');

  const handleCodeChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const sanitised = e.target.value.replace(/\D/g, '').slice(0, VERIFICATION_CODE_LENGTH);
    setCode(sanitised);
  };

  return (
    <MfaFormContainer>
      <form method="POST" action="/user/mfa-verify-code">
        <StyledField
          label={codeLabel}
          required
          isFullWidth
          input={
            <StyledInput
              id="mfa_code"
              name="mfa_code"
              type="text"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={VERIFICATION_CODE_LENGTH}
              pattern={`[0-9]{${VERIFICATION_CODE_LENGTH}}`}
              value={code}
              onChange={handleCodeChange}
              placeholder={codePlaceholder}
              required
              isFullWidth
            />
          }
        />
        <HelperText>
          <FormattedMessage {...messages.codeHelper} />
        </HelperText>

        <ButtonRow>
          <SubmitButton
            type="submit"
            priority="primary"
            id="mfa-verify-button"
            disabled={code.length !== VERIFICATION_CODE_LENGTH}
          >
            <FormattedMessage {...buttonLabel} />
          </SubmitButton>
        </ButtonRow>
      </form>
    </MfaFormContainer>
  );
};
